module.exports = __webpack_public_path__ + "img/icon.50351bf3.png";